class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      const sectionHtml = parsedState.sections?.[section.id];
      if (!sectionElement || !sectionHtml) return;

      sectionElement.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
    });

    if (typeof window.updateBstCartIconCount === 'function') {
      const itemCount = resolveBstCartItemCount(parsedState);
      if (itemCount !== undefined) window.updateBstCartIconCount(itemCount);
    }

    if (typeof window.initBstCartDrawer === 'function') {
      window.initBstCartDrawer(this);
    }

    setTimeout(() => {
      if (typeof window.initBstCartDrawer === 'function') {
        window.initBstCartDrawer(this);
      }
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return '';

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    if (selector) {
      const target = parsed.querySelector(selector);
      if (target) return target.innerHTML;
    }

    const fallback = parsed.querySelector('.shopify-section') || parsed.body;
    return fallback ? fallback.innerHTML : html;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
    ];
  }
}

function resolveBstCartItemCount(cartData) {
  if (cartData?.item_count !== undefined) return cartData.item_count;

  const cartDrawerSectionHtml = cartData?.sections?.['cart-drawer'];
  if (!cartDrawerSectionHtml) return undefined;

  const countEl = new DOMParser()
    .parseFromString(cartDrawerSectionHtml, 'text/html')
    .querySelector('.bst-cart-drawer__count');
  if (!countEl) return undefined;

  const count = parseInt(countEl.textContent, 10);
  return Number.isNaN(count) ? undefined : count;
}

function updateBstCartIconCount(itemCount) {
  const cartLink = document.getElementById('cart-icon-bubble');
  if (!cartLink) return;

  let countEl = cartLink.querySelector('.bst-header__cart-count');

  if (itemCount > 0) {
    if (!countEl) {
      countEl = document.createElement('span');
      countEl.className = 'bst-header__cart-count';
      countEl.setAttribute('aria-hidden', 'true');
      cartLink.appendChild(countEl);
    }
    countEl.textContent = itemCount;
  } else if (countEl) {
    countEl.remove();
  }
}

window.updateBstCartIconCount = updateBstCartIconCount;

if (window.PUB_SUB_EVENTS && typeof subscribe === 'function') {
  subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
    const itemCount = resolveBstCartItemCount(event?.cartData);
    if (itemCount !== undefined) updateBstCartIconCount(itemCount);
  });
}

customElements.define('cart-drawer-items', CartDrawerItems);
